import flatpickr from 'flatpickr'; // eslint-disable-line no-unused-vars
import { Russian } from 'flatpickr/dist/l10n/ru.js'; // eslint-disable-line import/extensions
import Chart from 'chart.js';

const $period = $('.author-sales__period');
const $calendarInputBlock = $('.author-sales__calendar-input-block');
// Документация графиков: https://www.chartjs.org/
// Опции графиков
const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    legend: {
        display: false,
    },
    tooltips: {
        enabled: false,
    },
    scales: {
        yAxes: [{
            ticks: {
                min: 0,
                fontSize: 10,
                fontFamily: 'Roboto',
            },
            gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea: true,
            },
        }],
        xAxes: [{
            ticks: {
                autoSkip: false,
                fontSize: 10,
                fontFamily: 'Roboto',
            },
            gridLines: {
                display: true,
                drawBorder: true,
                drawOnChartArea: true,
            },
        }],
    },
};

// Инициализация графика скачиваний
function initDownloadChart() {
    if ($('#sales-chart').length > 0) {
        const convasSales = document.getElementById('sales-chart');
        const ctxSales = convasSales.getContext('2d');
        const $dataTimelineSales = JSON.parse($(convasSales).attr('data-timeline'));
        const $dataSellingSales = JSON.parse($(convasSales).attr('data-selling'));

        return new Chart(ctxSales, {
            type: 'bar',
            data: {
                labels: $dataTimelineSales,
                datasets: [{
                    type: 'bar',
                    lineTension: 0,
                    data: $dataSellingSales,
                    borderWidth: 3,
                    borderColor: 'transparent',
                    pointBackgroundColor: '#f07c29',
                    backgroundColor: '#f07c29',
                    hoverBackgroundColor: '#f07c29',
                    pointRadius: 0,
                }],
            },
            options: chartOptions,
        });
    }

    return false;
}

// Инициализация графика онлайн-чтений
function initOnlineReadingChart() {
    if ($('#online-reading-chart').length > 0) {
        const convasOnlineReading = document.getElementById('online-reading-chart');
        const ctxOnlineReading = convasOnlineReading.getContext('2d');
        const $dataTimelineOnlineReading = JSON.parse($(convasOnlineReading).attr('data-timeline'));
        const $dataSellingOnlineReading = JSON.parse($(convasOnlineReading).attr('data-selling'));

        return new Chart(ctxOnlineReading, {
            type: 'bar',
            data: {
                labels: $dataTimelineOnlineReading,
                datasets: [{
                    type: 'bar',
                    lineTension: 0,
                    data: $dataSellingOnlineReading,
                    borderWidth: 3,
                    borderColor: 'transparent',
                    pointBackgroundColor: '#f07c29',
                    backgroundColor: '#f07c29',
                    hoverBackgroundColor: '#f07c29',
                    pointRadius: 0,
                }],
            },
            options: chartOptions,
        });
    }

    return false;
}

// Изменение выбора периода в выпадашке-селекте
function changeDropDown(element) {
    const cActive = 'drop-down__item_active';

    $('.author-sales__period-select-value').html(element.html());
    element.siblings('.drop-down__item').removeClass(cActive);
    element.addClass(cActive);
}

// Инициализация графиков
const chartOnlineReading = initOnlineReadingChart();
const chartSales = initDownloadChart();

// Отправка даты
function sendDataRange(dateRange, type) {
    const host = type === 'sum' ? $period.attr('data-host') : $calendarInputBlock.attr('data-host');

    if (host?.length) {
        if (type === 'sum') { // Запрос данных по периоду из селекта
            const $reportBtn = $('.author-sales__report-btn');

            // Дисейблим кнопку скачивания отчета
            $reportBtn.addClass('btn_disabled').attr('href', '');

            $.ajax({
                type: 'POST',
                data: { dateRange },
                url: host,
                success: (d) => {
                    let data = $.parseJSON(d);

                    if (data.data !== undefined) {
                        data = data.data;

                        if (typeof data.royalty === 'number' && data.royalty > 0) {
                            $('.author-sales__report-sum').text(`${data.royalty.toLocaleString()} ₽`);
                        } else {
                            $('.author-sales__report-sum').html('<span class="author-sales__report-sum-text">Нет данных</span>');
                        }

                        if (typeof data.report_link === 'string') {
                            $reportBtn.removeClass('btn_disabled').attr('href', data.report_link);
                        }

                        $('.book-row-btn__text-count').text('0');
                        $('.book-row-btn__text-royalty').text('0');

                        if (data?.books?.length) {
                            for (let i = 0; i < data.books.length; i++) {
                                const $item = $(`.book-row-btn-list__item[data-id=${data.books[i].id}]`);
                                const count = data.books[i].count;
                                const royalty = data.books[i].royalty;

                                if (count) {
                                    $item.find('.book-row-btn__text-count').text(count);
                                }

                                if (royalty) {
                                    $item.find('.book-row-btn__text-royalty').text(royalty);
                                }
                            }
                        }
                    } else if (typeof data.error === 'string') {
                        showError(data.error);
                    } else {
                        showError();
                    }
                },
                error: () => showError(),
            });
        } else { // Запрос данных по периоду из календаря
            const $sales = $('.author-sales__royalty-sales');
            const $salesBlock = $sales.closest('.author-sales__info-block');
            const $onlineReading = $('.author-sales__royalty-online-reading');
            const $onlineReadingBlock = $onlineReading.closest('.author-sales__info-block');

            $.ajax({
                type: 'POST',
                data: { dateRange },
                url: host,
                success: (d) => {
                    let data = $.parseJSON(d);

                    if (data.data !== undefined) {
                        data = data.data;

                        if (data?.royalty_sales && data.royalty_sales !== 0) {
                            $salesBlock.removeClass('hidden');

                            if (typeof data.royalty_sales === 'number') {
                                $sales.text(data.royalty_sales.toLocaleString());
                            } else {
                                $sales.text('');
                            }
                        } else {
                            $salesBlock.addClass('hidden');
                        }

                        if (data?.royalty_online_reading && data.royalty_online_reading !== 0) {
                            $onlineReadingBlock.removeClass('hidden');

                            if (typeof data.royalty_online_reading === 'number') {
                                $onlineReading.text(data.royalty_online_reading.toLocaleString());
                            } else {
                                $onlineReading.text('');
                            }
                        } else {
                            $onlineReadingBlock.addClass('hidden');
                        }

                        if (data?.chart_sales?.selling && data.chart_sales?.timeline && $('#sales-chart').length > 0) {
                            if (chartSales) {
                                chartSales.data.datasets[0].data = data.chart_sales.selling;
                                chartSales.data.labels = data.chart_sales.timeline;
                                chartSales.update();
                            }
                        }

                        if (data?.chart_online_reading?.selling && data.chart_online_reading?.timeline && $('#online-reading-chart').length > 0) {
                            if (chartOnlineReading) {
                                chartOnlineReading.data.datasets[0].data = data.chart_online_reading.selling;
                                chartOnlineReading.data.labels = data.chart_online_reading.timeline;
                                chartOnlineReading.update();
                            }
                        }

                        if (data?.table_sales) {
                            $('.author-sales__table[data-table-name=sales] tbody').html(getTableHtml(data.table_sales));
                        }

                        if (data?.table_online_reading) {
                            $('.author-sales__table[data-table-name=online-reading] tbody').html(getTableHtml(data.table_online_reading));
                        }

                        if (data?.alert && data.alert.length > 0) {
                            $('.author-sales__alert').show().html(data.alert);
                        } else {
                            $('.author-sales__alert').hide();
                        }
                    } else if (typeof data.error === 'string') {
                        showError(data.error);
                    } else {
                        showError();
                    }
                },
                error: () => showError(),
            });
        }
    } else {
        showError('отсутствует адрес запроса');
    }
}

// Обновление html таблицы
function getTableHtml(arr) {
    let html = '';

    for (let i = 0; i < arr.length; i++) {
        html += `<tr>
                    <td>${arr[i].name}</td>
                    <td>${arr[i].quantity}</td>
                </tr>`;
    }

    return html;
}

// Вывод ошибки
function showError(message) {
    if (message) {
        $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${message}"</p></div>`);
    } else {
        $.fancybox.open('<div><p class="text text_c-gray">Ошибка</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
    }
}

function getSort(e) {
    const o = -(e.target.dataset.order || -1);
    const thList = Array.from(e.target.parentNode.cells);
    const i = thList.indexOf(e.target);
    const collator = new Intl.Collator(['en', 'ru'], { numeric: true });
    const comparator = (index, order) => (a, b) => (
        order
        * collator.compare(a.children[index].textContent, b.children[index].textContent)
    );
    const tablesBodies = Array.from(e.target.closest('table').tBodies);

    tablesBodies.forEach((tBody) => {
        tBody.append(...Array.from(tBody.rows).sort(comparator(i, o)));
    });

    thList.forEach((th) => th.classList.toggle('sorted', th === e.target));
}

if ($calendarInputBlock.length > 0) {
    const defaultDate = JSON.parse($calendarInputBlock.attr('data-default-date-range'));
    let dateRangeResult = defaultDate;
    let updateCalendar = false;
    // Инициализация календаря
    const calendar = $('.author-sales__calendar-input').flatpickr({
        'mode': 'range',
        'locale': Russian,
        'dateFormat': 'd.m.Y',
        'defaultDate': defaultDate,
        // minDate: defaultDate[0],
        // maxDate: defaultDate[1],
        'minDate': '01.01.2020',
        'onClose': function (selectedDates) {
            if (updateCalendar) { // Если даты были изменены
                dateRangeResult = [];

                if (selectedDates.length === 1) {
                    // Если число только одно, ставим его началом и концом периода
                    dateRangeResult = [calendar.formatDate(selectedDates[0], 'd.m.Y'), calendar.formatDate(selectedDates[0], 'd.m.Y')];
                    calendar.setDate(dateRangeResult); // Если установлена 1 дата и календарь закрыт, ставим 2-ю дату равную 1-ой
                } else if (selectedDates.length === 0) {
                    // Если число нет, ставим дефолтный период
                    dateRangeResult = defaultDate;
                    calendar.setDate(defaultDate);
                } else {
                    dateRangeResult = [calendar.formatDate(selectedDates[0], 'd.m.Y'), calendar.formatDate(selectedDates[1], 'd.m.Y')];
                }

                updateCalendar = false;
                sendDataRange(dateRangeResult);
            }
        },
        'onValueUpdate': function () {
            updateCalendar = true;
        },
    });

    sendDataRange(dateRangeResult);
}

if ($period.length > 0) {
    // Нажатие на элемент выпадашки выбора периода
    $('.author-sales__link-drop-down .drop-down__item').on('click', function () {
        const $this = $(this);
        const $linkDropDown = $this.closest('.author-sales__link-drop-down');
        const dataDateRange = $this.attr('data-date-range');
        const dateRange = typeof dataDateRange === 'string' ? JSON.parse(dataDateRange) : [];

        $linkDropDown.trigger('eksmoCallLinkDropDownClose'); // Закрываем выпадашку

        if (!$this.hasClass('drop-down__item_active')) {
            changeDropDown($this);

            if (dateRange.length > 0) {
                // Изменения в календаре
                /* if($calendarInputBlock.length > 0) {
                    // Очистка выбранных дат в календаре
                    calendar.clear();

                    // Псевдообнуление ограничений для избежания ошибок при установке новых дат в календаре
                    calendar.set('minDate', '01.01.1900');
                    calendar.set('maxDate', '01.01.2900');

                    // Установка нового периода и ограничний в календаре
                    calendar.setDate(dateRange);
                    calendar.set('minDate', dateRange[0]);
                    calendar.set('maxDate', dateRange[1]);
                } */

                sendDataRange(dateRange, 'sum');
            }
        }
    });
}

// Сортировка таблицы, взято отсюда: https://inter-net.pro/javascript/sort-table , итог взят от сюда: https://codepen.io/Sergei_Sergeevu4/pen/OJPgOao?editors=0010
if ($('.author-sales__table').length > 0) {
    const theads = document.querySelectorAll('.author-sales__table thead');

    theads.forEach((thead) => thead.addEventListener('click', getSort));
}